import React, { useRef } from 'react';
import Navbar from './navBar';

// 내비게이션과 관련된 모든 로직을 포함하는, 진정으로 재사용 가능한 컴포넌트
const CommonNavComponent = ({ categories }) => {
  const sectionRefs = useRef(categories.map(() => React.createRef()));

  const handleNavClick = idx => {
    // 선택된 섹션으로 스무스 스크롤 이동 (고정 헤더 높이 고려)
    const node = sectionRefs.current[idx]?.current;
    if (node) {
      const top = node.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <div className="detail-body-info-wrapper">
      {categories.map((section, idx) => {
        // 부모로부터 렌더링할 컴포넌트를 직접 받습니다.
        const ContentComponent = section.Component;

        return (
          <div key={section.id} ref={sectionRefs.current[idx]}>
            <div className="detail-body-info">
              <Navbar
                navItems={categories.map(c => ({ id: c.id, label: c.name }))}
                activeIndex={idx}
                onNavClick={handleNavClick}
              />
              <div className={idx === categories.length - 1 ? 'tab-contents last' : 'tab-contents'}>
                {/* 전달받은 컴포넌트를 데이터와 함께 렌더링합니다. */}
                {ContentComponent && <ContentComponent {...section.data} />}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CommonNavComponent;
